import Axios from 'axios';
import { Config } from '../apiRoutes';
import mime from 'mime';

import {
  ASSIGNMENTS_INDEX_REQUESTED,
  ASSIGNMENTS_INDEX_SUCCESS,
  ASSIGNMENTS_INDEX_FAILURE,
  ASSIGNMENTS_CREATE_REQUESTED,
  ASSIGNMENTS_CREATE_SUCCESS,
  ASSIGNMENTS_CREATE_FAILURE,
  ASSIGNMENTS_UPDATE_REQUESTED,
  ASSIGNMENTS_UPDATE_SUCCESS,
  ASSIGNMENTS_UPDATE_FAILURE,
  ASSIGNMENTS_DELETE_REQUESTED,
  ASSIGNMENTS_DELETE_SUCCESS,
  ASSIGNMENTS_DELETE_FAILURE,
  ASSIGNMENTS_BY_ITEM_REQUESTED,
  ASSIGNMENTS_BY_ITEM_SUCCESS,
  RESET_ASSIGNMENTS_STATE,
  UPLOAD_TOKEN_REQUESTED,
  UPLOAD_TOKEN_SUCCESS,
  ASSIGNMENTS_CSV_UPLOAD_REQUESTED,
  ASSIGNMENTS_CSV_UPLOAD_SUCCESS,
  ASSIGNMENTS_CSV_UPLOAD_FAILURE,
  ASSIGNMENTS_CSV_PROCESS_REQUESTED,
  ASSIGNMENTS_CSV_PROCESS_SUCCESS,
  ASSIGNMENTS_CSV_PROCESS_FAILURE,
  ASSIGNMENT_CREATE_REQUESTED,
  ASSIGNMENT_CREATE_SUCCESS,
  ASSIGNMENT_CREATE_FAILURE,
  GET_ASSIGNMENT_THRESHOLDS_REQUESTED,
  GET_ASSIGNMENT_THRESHOLDS_SUCCESS,
  GET_ASSIGNMENT_THRESHOLDS_FAILURE,
} from '../types';

export const assignmentsIndexRequested = () => {
  return {
    type: ASSIGNMENTS_INDEX_REQUESTED
  }
};

export const assignmentsIndexSuccess = (assignments, page) => {
  return {
    type: ASSIGNMENTS_INDEX_SUCCESS,
    payload: assignments,
    page: page,
  }
};

export const assignmentsIndexFailure = () => {
  return {
    type: ASSIGNMENTS_INDEX_FAILURE
  }
};

export const assignmentsCreateRequested = () => {
  return {
    type: ASSIGNMENTS_CREATE_REQUESTED
  }
};

export const assignmentsCreateSuccess = (assignmentResponse) => {
  return {
    type: ASSIGNMENTS_CREATE_SUCCESS,
    payload: assignmentResponse
  }
};

export const assignmentsCreateFailure = () => {
  return {
    type: ASSIGNMENTS_CREATE_FAILURE
  }
};


export const assignmentCreateRequested = (assignmentRequest) => {
  return {
    type: ASSIGNMENT_CREATE_REQUESTED,
    payload: assignmentRequest
  }
}

export const assignmentCreateSuccess = (assignmentResponse) => {
  return {
    type: ASSIGNMENT_CREATE_SUCCESS,
    payload: assignmentResponse
  }
}

export const assignmentCreateFailure = () => {
  return {
    type: ASSIGNMENT_CREATE_FAILURE
  }
}

export const assignmentUpdateRequested = (assignmentId) => {
  return {
    type: ASSIGNMENTS_UPDATE_REQUESTED,
    assignmentId: assignmentId
  }
};

export const assignmentUpdateSuccess = (response, assignmentId) => {
  return {
    type: ASSIGNMENTS_UPDATE_SUCCESS,
    response: response.assignment,
    assignmentId: assignmentId
  }
};

export const assignmentUpdateFailure = (assignmentId) => {
  return {
    type: ASSIGNMENTS_UPDATE_FAILURE,
    assignmentId: assignmentId
  }
};


export const assignmentDeleteRequested = (assignmentId, productId, variationId, supplierId) => {
  return {
    type: ASSIGNMENTS_DELETE_REQUESTED,
    assignmentId: assignmentId,
    productId: productId,
    variationId: variationId,
    supplierId: supplierId,
  }
};

export const assignmentDeleteSuccess = (response, assignmentId) => {
  return {
    type: ASSIGNMENTS_DELETE_SUCCESS,
    response: response,
    assignmentId: assignmentId
  }
};

export const assignmentDeleteFailure = () => {
  return {
    type: ASSIGNMENTS_DELETE_FAILURE
  }
};

export const assignmentsByItemRequested = (itemKey) => {
  return {
    type: ASSIGNMENTS_BY_ITEM_REQUESTED,
    itemKey: itemKey
  }
}


export const assignmentsByItemSuccess = (itemKey, response) => {
  return {
    type: ASSIGNMENTS_BY_ITEM_SUCCESS,
    itemKey: itemKey,
    response: response
  }
}

export const resetState = () => {
  return {
    type: RESET_ASSIGNMENTS_STATE,
  }
}



export const setUploadTokenRequested = () => {
  return {
    type: UPLOAD_TOKEN_REQUESTED
  }
};

export const setUploadTokenSuccess = (uploadLink) => {
  return {
    type: UPLOAD_TOKEN_SUCCESS,
    uploadLink: uploadLink
  }
};

export const setUploadRequested = () => {
  return {
    type: ASSIGNMENTS_CSV_UPLOAD_REQUESTED
  }
};

export const setUploadSuccess = () => {
  return {
    type: ASSIGNMENTS_CSV_UPLOAD_SUCCESS
  }
};

export const setUploadFailure = () => {
  return {
    type: ASSIGNMENTS_CSV_UPLOAD_FAILURE
  }
};

export const startCsvProcessRequested = () => {
  return {
    type: ASSIGNMENTS_CSV_PROCESS_REQUESTED
  }
};

export const startCsvProcessSuccess = () => {
  return {
    type: ASSIGNMENTS_CSV_PROCESS_SUCCESS
  }
};

export const processCsvRequested = () => {
  return {
    type: ASSIGNMENTS_CSV_PROCESS_REQUESTED
  }
}

export const processCsvSucess = () => {
  return {
    type: ASSIGNMENTS_CSV_PROCESS_SUCCESS
  }
}

export const processCsvFailure = () => {
  return {
    type: ASSIGNMENTS_CSV_PROCESS_FAILURE
  }
}


export const getAssignmentThresholdsRequested = (itemKey) => {
  return {
    type: GET_ASSIGNMENT_THRESHOLDS_REQUESTED,
    itemKey: itemKey
  }
}

export const getAssignmentThresholdsSuccess = (itemKey, assignment) => {
  return {
    type: GET_ASSIGNMENT_THRESHOLDS_SUCCESS,
    itemKey: itemKey,
    response: assignment
  }
}


export const assignmentsIndex = (signedPayload, supplierId, continuationToken, page) => {
  return (dispatch) => {
    dispatch(assignmentsIndexRequested());

    let endPoint = Config.baseUrl + Config.suppliers + `${supplierId}/` + Config.assignments;

    if (continuationToken) {
      endPoint = endPoint + `?continuationToken=${continuationToken}`;
    }

    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(assignmentsIndexSuccess(response.data, page));
      })
  }
}

export const assignmentsByItem = (signedPayload, supplierId, productId, variationId) => {
  return (dispatch) => {
    dispatch(assignmentsByItemRequested(`${productId}/${variationId}`));

    let endPoint = Config.baseUrl + Config.assignments + `?supplier_id=${supplierId}&product_id=${productId}`;

    if(variationId) {
      endPoint = endPoint + `&variation_id=${variationId}`
    }

    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(assignmentsByItemSuccess(`${productId}/${variationId}`, response.data));
      })
  }
}



export const assignmentsCreate = (signedPayload, supplierId, assignments, assignmentValues) => {
  return (dispatch) => {
    console.log(supplierId);
    console.log(assignments)
    console.log(assignmentValues);

    dispatch(assignmentsCreateRequested());

    let endPoint = Config.baseUrl + Config.assignments;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.post(endPoint, { supplierId: supplierId, assignments: assignments, assignmentValues: assignmentValues }, { headers: headers })
      .then((response) => {
        dispatch(assignmentsCreateSuccess(response.data));
      })
  }
}

export const assignmentCreate = (signedPayload, supplierId, assignmentValues) => {
  return (dispatch) => {
    dispatch(assignmentCreateRequested({ supplierId: supplierId, assignmentValues: assignmentValues }));

    let endPoint = Config.baseUrl + Config.assignment;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.post(endPoint, { supplierId: supplierId, assignmentValues: assignmentValues }, { headers: headers })
      .then((response) => {
        dispatch(assignmentCreateSuccess({ supplierId: supplierId, assignmentValues: assignmentValues }));
      })
  }
}

export const assignmentUpdate = (signedPayload, supplierId, assignment, assignmentValues) => {
  return (dispatch) => {
    let assignmentId = `${parseInt(assignment.product_id)}/${assignment.variation_id ? parseInt(assignment.variation_id) : null}`;

    dispatch(assignmentUpdateRequested(assignmentId));

    let endPoint = Config.baseUrl + Config.assignment;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.put(endPoint, { supplierId: supplierId, assignment: assignment, assignmentValues: assignmentValues }, { headers: headers })
      .then((response) => {
        dispatch(assignmentUpdateSuccess(response.data, assignmentId));
      })
  }
}

export const assignmentDelete = (signedPayload, supplierId, assignment) => {
  return (dispatch) => {
    console.log(assignment);

    let assignmentId = `${assignment.product_id}/${assignment.variation_id || null}`;
    dispatch(assignmentDeleteRequested(assignmentId, assignment.product_id, assignment.variation_id, supplierId));

    let endPoint = Config.baseUrl + Config.assignment + `?supplier_id=${supplierId}&product_id=${assignment.product_id}`;

    if(assignment.variation_id) {
      endPoint = endPoint + `&variation_id=${assignment.variation_id}`
    }

    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.delete(endPoint, { headers: headers })
      .then((response) => {
        dispatch(assignmentDeleteSuccess(response, assignmentId));
      })
  }
}

export const reset = () => {
  return (dispatch)  =>{
    dispatch(resetState());
  }
}

export const getAssignmentThresholds = (signedPayload, productId, variationId) => {
  return (dispatch) => {
    dispatch(getAssignmentThresholdsRequested(`${productId}/${variationId}`));

    let endPoint = Config.baseUrl + Config.thresholds + `?product_id=${productId}`;

    if(variationId) {
      endPoint = endPoint + `&variation_id=${variationId}`
    }

    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(getAssignmentThresholdsSuccess(`${productId}/${variationId}`, response.data));
      })
  }
}



export const uploadAssignments = (signedPayload, file, supplierId) => {
  return (dispatch) => {
    dispatch(setUploadTokenRequested());

    let lastPeriodIndex = file.name.lastIndexOf(".");
    let extension = file.name.substring(lastPeriodIndex + 1);
    let fileNameWithoutExtension = file.name.substring(0, lastPeriodIndex);
    let cleanedFileName = fileNameWithoutExtension.replace(/ /g, '_').replace(/\./g, '_') + '.' + extension;

    let endPoint = Config.baseUrl + Config.assignments + '/' + Config.upload + '/' + cleanedFileName;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(setUploadTokenSuccess(response.data));
        dispatch(uploadAssignmentFile(signedPayload, file, response.data.action.upload_link, cleanedFileName, supplierId));
      })

  }
}

export const uploadAssignmentFile = (signedPayload, file, uploadLink, cleanedFileName, supplierId) => {
  return (dispatch) => {
    dispatch(setUploadRequested());

    let type = mime.getType(file.name);

    var options = {
        headers: {
          'Content-Type': type
        }
      };

    Axios.put(uploadLink, file, options).then((response) => {
      console.log(response);
      dispatch(setUploadSuccess());
      dispatch(processCsv(signedPayload, cleanedFileName, supplierId));
    })
    .catch((error) => {
      dispatch(setUploadFailure(error));
    })
    ;
  }
}

export const processCsv = (signedPayload, cleanedFileName, supplierId) => {
  return (dispatch) => {
    dispatch(processCsvRequested());

    let endPoint = Config.baseUrl + Config.assignments + '/' + Config.process + '/' + cleanedFileName + `?supplier_id=${supplierId}`;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(processCsvSucess());
      })
      .catch((error) => {
        dispatch(processCsvFailure(error));
      })
  }
}

